import React,{useContext, useEffect} from 'react';
import './Home.css'
import MainMenu from '../../components/mainMenu/MainMenu';
import CreatePost from '../../components/createPost/CreatePost';
import ShowStory from './showStory/ShowStory';
import ShortingAndFilter from '../../components/shortingAndFilter/ShortingAndFilter';
import RightSitebarMenu from '../../components/rightSitebarMenu/RightSitebarMenu';
import ShowPosts from './showPosts/ShowPosts';
import LeftSitebarMenu from './../../components/leftSitebarMenu/LeftSitebarMenu';
import closerIcon from '../../assets/img/feed-imgs/navbar/closeicon.svg';
import { ShowHideSitebar } from '../../App';

const Home = () => {
    // const [ showRightMenuStatus, setShowRightMenuStatus ] = useState(false);
    // const toggleShowRightMenu = () =>{
    //     console.log(showRightMenuStatus, "yes Clicked")
    //     setShowRightMenuStatus(!showRightMenuStatus)
    // }
    const [showHideSidebar, setShowHideSidebar] = useContext(ShowHideSitebar)
    useEffect(()=>{ /** setting the page name for the sidebars of this page to work */
        const setPageName = {...showHideSidebar}
        setPageName.pageName = 'home';
        setPageName.home.left = false;
        setPageName.home.right = false;
        setShowHideSidebar(setPageName)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const closeSidebar =(whichSidebar, status)=>{
        const newStatus = {...showHideSidebar}
        if(whichSidebar === 'left'){
            newStatus.home.left = status /** changing the page name for left sidebar to toggle */
            setShowHideSidebar(newStatus) /** changing the page name for right sidebar to toggle */
        }
        if(whichSidebar === 'right'){
            newStatus.home.right = status
            setShowHideSidebar(newStatus)
        }
    }
    return (
        <div>
            <MainMenu></MainMenu>
            {/* Menu bar start here */}
            <div className="container-fluid container-xxl">
                <div className="row gap-5 gap-lg-0">
                    {/* Left Site Bar Start here */}
                    <div className={`col-12 col-lg-2  d-lg-block ${showHideSidebar?.home?.left ? 'd-block right-sitebarmenu' : 'd-none'}`}>
                        <div className="d-flex d-lg-none justify-content-end mb-3">
                            <div onClick={()=>closeSidebar("left", false)} className="d-flex justify-content-center align-items-center action-button rounded-circle shadow-sm p-2 m-3" style={{ height: "32px", width: "32px"}}>
                                <img src={closerIcon} alt="" className='close-menu-button' />
                            </div>
                        </div>
                        <LeftSitebarMenu></LeftSitebarMenu>
                    </div>    
                    {/* left Site Bar End Hre */}

                    {/* Center Align Items Code start Here*/}

                    <div className="col-12 col-lg-6">
                        {/* Show Story Section here */}
                         <ShowStory />
                        {/* Create a Post */}
                        <CreatePost />
                       {/* Shorting and Filter  */}
                       <ShortingAndFilter />
                        {/* Show Posts Here */}
                        <ShowPosts />
                    </div>
                    <div className={`col-12 col-lg-4  d-lg-block ${showHideSidebar?.home?.right ? 'd-block right-sitebarmenu' : 'd-none'}`}>
                    <div className="d-flex d-lg-none justify-content-end my-2">
                        <div onClick={()=>closeSidebar("right", false)} className="d-flex justify-content-center align-items-center action-button rounded-circle shadow-sm p-2 m-3" style={{ height: "32px", width: "32px"}}>
                                <img src={closerIcon} alt="" className='close-menu-button' />
                            </div>
                        </div>
                        <RightSitebarMenu />
                    </div>          
                </div>
            </div>
        </div>
    );
};

export default Home;